/**
 * @param {object} item - Item
 * @param {object[]} columns - Column data
 * @param {number[]} number - qualifierRow
 * @param finalsCutOff
 * @param topFinalsCutOff
 * @param conferenceLabel
 * @param premWinner
 * @param competitionId
 * @param compSeasonId
 * @param roundId
 * @param roundNumber
 * @param topFinalsCutOff
 * @returns {object[]} qualifierRow - row data
 */
export const composeRowData = (
    item,
    columns,
    finalsCutOff,
    topFinalsCutOff,
    conferenceLabel,
    premWinner,
    competitionId,
    compSeasonId,
    roundNumber
) => {
    let rowData = {};
    columns.forEach((column) => {
        const accessor = column.accessor;
        rowData[accessor] = item[accessor];
    });

    rowData.clubName = item.club;
    rowData.isConference = conferenceLabel ? true : false;
    rowData.premWinner = premWinner || false;
    rowData.competitionId = competitionId;
    rowData.compSeasonId = compSeasonId;
    rowData.roundNumber = roundNumber;
    rowData.isActiveClub =
        window?.CLUB_ID === rowData?.club?.club?.id?.toString();
    rowData.byeUpNext = item?.byeUpNext || false;

    // Calculate cutoff positions

    // If wildcard (top cutoff exists)
    if (topFinalsCutOff) {
        rowData.firstCutOff = Math.min(finalsCutOff, topFinalsCutOff);
        rowData.secondCutOff = Math.max(finalsCutOff, topFinalsCutOff);
    } else {
        // Else non-wildcard comp
        rowData.firstCutOff = finalsCutOff;
    }

    return rowData;
};
